"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function debug(msg) {
    if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test') {
        console.warn(msg);
    }
}
exports.debug = debug;
//# sourceMappingURL=debug.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/debug.js
// module id = QAcS
// module chunks = 20 21